import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/mcp/usage.mcpPortfolio.query.gql"
import type {
  UsageMcpPortfolioQuery,
  UsageMcpPortfolioQueryVariables,
} from "@/v2-backoffice-client/usage/mcp/__types__/usage.mcpPortfolio.query"

type Options = QueryHookOptions<
  UsageMcpPortfolioQuery,
  UsageMcpPortfolioQueryVariables
>

export function useUsageMcpPortfolioQuery(options?: Options) {
  return useQuery<UsageMcpPortfolioQuery, UsageMcpPortfolioQueryVariables>(
    query,
    options,
  )
}
